export const loogbook = {
    tabs: {
        activityRegister: 'Actividades',
        myActivity: 'Mis actividades',
        path: 'Recorrido',
        access: 'Acceso',
        catalog: 'Catálogo',
        dailyCuts: 'Cortes diarios',
        destinationsRegistered: 'Destinos registrados'
    },
    inputs: {
        activityName: 'Nombre de la actividad',
        freeTextSpecification: '¿Aplica descripción?',
        assignMeActivities: 'Asignarme actividades',
        assignedUnitsOnly: 'Solo unidades asignadas',
        destinationName: 'Nombre del destino',
        activityTypeText: 'Descripción',
        freeActivity: 'Esta es una actividad libre que no requiere de lapso de fechas'
    },
    titles: {
        convertToUnivty: 'Convertir a unidad',
        destinationRegistered: 'Destinos registrados',
        preview: 'Vista previa',
        gerentDestination: 'Gerente: {{gerent}}',
        activitiesOnThisUnity : 'Actividades en esta unidad',
        title:'Titulo de la actividad',
        logbookTable: 'Gestión de accesos al módulo de bitácora',
        typeOfActivityDescription: 'Descripción del tipo de actividad',
        initActivityDate: 'Fecha de inicio de la actividad',
        startDate: 'Fecha inicial',
        endDate: 'Fecha final',
        closeType: 'Tipo de cierre',
        execution: 'EJECUCIÓN',
        normal: 'Normal',
        forced: 'Forzoso',
        forcedComment: 'COMENTARIO DE CIERRE FORZOSO',
        selectedUsers: 'Usuarios seleccionados',
        userLogbook: 'Bitácora de usuarios',
        chargeEvidence: 'Cargar evidencias adjuntas',
        activityList: 'Listado de actividades',
        destinationsList: 'Listado de destinos',
        listOfDailyCuts: 'Listado de cortes diarios',
        catalogueOfActivities: 'Catálogo de actividades',
        newTypeOfActivity: 'Nuevo tipo de actividad',
        typeOfActivity: 'Tipo de actividad',
        activityTour: 'Recorrido de la actividad',
        createActivity: 'Creación de actividades',
        SelectUsersToAssignActivities: 'Seleccione los usuarios para asignar actividades',
        activityByUserSettings: 'Configuración de actividad por usuario',
        activities: 'Actividades',
        activity: 'Actividad',
        noActivity: 'No se encontró actividades para mostrar',
        programming: 'Programación',
        destinationRequired: 'Destino*',
        userRequired: 'Usuario*',
        createDestination: 'Crear destino',
        editDestination: 'Editar destino',
        editActivity: 'Editar actividad',
        changeUser: 'Cambiar usuario',
        allActivitiesCreated: 'Todas las actividades se crearon exitosamente',
        evidences: 'EVIDENCIAS',
        returnToTheListOfDailyCuts: 'Volver al listado de cortes diarios',
        resendDailyCuts: 'Reenviar cortes diarios',
        totalOfDailyCuts: 'Número de cortes diarios a reenviar:',
        search: 'Buscador',
        destinaitonInformation: 'Información del destino'
    },
    buttons: {
        close: 'Cerrar',
        selectUnity: 'Seleccionar unidad',
        selectDestination: 'Seleccionar destino',
        createDestination: 'Crear destino',
        editDestination: 'Editar destino',
        editUnity: 'Editar unidad',
        select: 'Seleccionar',
        continue: 'Regresar al listado de actividades',
        seeMore: 'Ver más',
        seeLess: 'Ver menos',
        seeAll: 'Ver todo',
        hiddenAll: 'Ocultar todo',
        seeMap: 'Ver mapa',
        hiddenMap: 'Ocultar mapa',
        destionation: 'Destinos',
        change: 'Cambiar',
        create: 'Crear',
        destionationRegister: 'Registrados'
    },
    pointType: {
        unity: 'Unidad',
        start: 'Inicio',
        end: 'Fin',
        unity_start_end: 'Unidad - Inicio - Fin',
        unity_start: 'Unidad - Inicio',
        unity_end: 'Unidad - Fin',
        start_end: 'Inicio - Fin'
    },
    pointTitle: {
        unity: 'Punto de unidad',
        start: 'Punto inicial',
        end: 'Punto final',
        unity_start_end: 'Punto de actividad',
        unity_start: 'Punto inicial',
        unity_end: 'Punto final',
        start_end: 'Punto inicial y final'
    },
    noActivitiesAssigned: 'No hay actividades asignadas. Puedes asignar una usando el formulario a la izquierda.',
    noLocationSelected: 'No se ha seleccionado una ubicación.',
    noDestination: 'No se encontraron destinos registrados.',
    free: 'Libre',
    activitiesCount: 'Conteo de actividades',
    company: 'Compañía',
    latitudeAndLongitude: 'Latitud y longitud',
    userCreator: 'Usuario creador',
    createdDate: 'Fecha de creación',
    direction: 'Dirección',
    total: 'Total:',
    division: 'División',
    curp: 'CURP',
    area: 'Área',
    role: 'Rol',
    department: 'Departamento',
    programmed: 'Programada',
    automatic: 'Automática',
    programationType: 'Tipo de programación',
    startAndEndDate: 'Fecha inicio y fin de ejecución',
    storeId: 'ID - Unidad / Destino',
    endStoreId: 'ID - Unidad / Destino de cierre',
    initLocation: 'Ubicación de inicio',
    finishLocation: 'Ubicación de fin',
    location: 'Ubicación',
    startLocation: 'Ubicación inicial',
    endLocation: 'Ubicación final',
    countActivities: 'Esta unidad tiene {{count}} actividades asociadas',
    countActivitiesDestination: 'Este destino tiene {{count}} actividades asociadas',
    viewOnTheMap: 'Ver en el mapa',
    catalogueOfActivities: 'Catálogo de actividades',
    newTypeOfActivity: 'Nuevo tipo de actividad',
    typeOfActivity: 'Tipo de actividad',
    reScheduleActivity: 'Reagendar actividad',
    tabsChildren: {
        addUsers: 'Agregar usuarios',
        permissions: 'Asignación de permisos'
    },
    addAcitivity: 'Crear actividad',
    activity: 'Actividades',
    destination: 'Destinos',
    newActivity: 'Nueva actividad',
    startActivity: 'Iniciar actividad',
    finishActivity: 'Finalizar actividad',
    generateDetailInform: 'Generando informe resumen',
    generateDestinations: 'Generando descarga',
    "modal": {
        "doYouWantToRegisterTheDestination" : "¿Desea registrar el destino?",
        "areYouSureYouWantToRegisterThisDestination": "¿Estás seguro que deseas registrar el destino seleccionado?",
        "deleteSettingsTitle": "¿Estás seguro de que quieres desactivar este permiso?",
        "deleteSettingsDescription": "Se perderán los permisos de ver reporte o reenviar reporte.",
        "deleteSettingsPermission_one": "¿Estás seguro de que quieres eliminar el usuario seleccionado?",
        "deleteSettingsPermission_other": "¿Estás seguro de que quieres eliminar los usuarios seleccionados?",
        "deletePermissionDescription": "Se perderán las configuraciones realizadas.",
        "deleteActivityTitle": "Eliminar tipo de actividad",
        "deleteActivityDescription": "¿Estás seguro de que deseas eliminar este tipo de actividad?",
        "deleteActivity": "¿Estás seguro de que deseas eliminar esta actividad?",
        "deleteDestination": "¿Estás seguro que deseas eliminar el destino seleccionado?",
        "assignAllUsersTtitle": "Asignar actividades a todos los usuarios",
        "assignAllUsersDescription": "¿Estás seguro de que quieres asignar las actividades a todos los usuarios? Se perderán las actividades asignadas anteriormente a cada usuario por individual.",
        "cancelEdit": "Cancelar la edición de la actividad",
        "cancelEditDescription": "¿Estás seguro de que quieres cancelar la edición de la actividades?",
        "changeActivityType": "Cambiar tipo de actividad",
        "changeActivityTypeDescription": "¿Estás seguro de que quieres cambiar el tipo de actividad? Se perderán las evidencias que han sido cargadas.",
        "deleteActivityType": "Eliminar tipo de actividad",
        "deleteActivityTypeDescription": "¿Estás seguro de que quieres eliminar el tipo de actividad? Se perderán las evidencias que han sido cargadas.",
        "delete": {
            "success": "La actividad se borró exitosamente.",
            "error": "Ocurrió un error al eliminar la actividad."
        },
        start: {
            title: '¿Estás seguro de que quieres iniciar la actividad?'
        },
        finish: {
            title: '¿Estás seguro de que quieres finalizar la actividad?'
        },
        startActivity: 'Para activar la actividad, debe estar activa la geolocalización.',
        finishActivity: 'Para finalizar la actividad, debe estar activa la geolocalización.',
        finishActivityOutRange: 'No puedes finalizar la actividad, ya que te encuentras fuera del rango.',
        startActivityOutRange: 'No puedes iniciar la actividad, ya que te encuentras fuera del rango.',
        "deleteSettingsTitle": "¿Estás seguro que quieres desactivar este permiso?",
        "deleteSettingsDescription": "se perderán los permisos de ver reporte o reenviar reporte",
        "deleteSettingsPermission_one": "¿Estás seguro que quieres eliminar el usuario seleccionado?",
        "deleteSettingsPermission_other": "¿Estás seguro que quieres eliminar los usuarios seleccionados?",
        "deletePermissionDescription": "se perderán las configuraciones realizadas",
        "deleteActivityTitle": "Eliminar tipo de actividad",
        "deleteActivityDescription": "¿Estás seguro que quieres eliminar este tipo de actividad?",
        "delete": {
            "success": "La actividad se borró exitosamente",
            "error": "Ocurrió un error al eliminar la actividad"
        }
    },
    "columns": {
        "activityName": "Nombre de la actividad",
        "numberOfRecords": "# Registros",
        "dateOfGeneration": "Fecha de generación"
    },
    returnActivityList: 'Volver al listado de actividades',
    addActivity: 'Agregar actividad',
    "snackbar": {
        "destionationAlreadyRegistered": "El destino ya está registrado en la lista de destinos.",
        "loadingReport": "Espere un momento, se esta generando el informe.",
        "success": "Se actualizaron los permisos de los usuarios.",
        "error": "Ocurrió un error y los permisos no se pudieron actualizar.",
        "errorMasiveActivities": "No se pudieron crear todas las actividades",
        requiredFields: "Algunas evidencias necesarias todavía no tienen archivos cargados.",
        thereAreNotSomeChange: "No se han realizado cambios.",
        startActivity: {
            "success": "La actividad se inició con éxito.",
            "error": "Ocurrió un error al iniciar la actividad.",
            pastDate: 'La fecha de inicio de la actividad es menor a la fecha actual.'
        },
        editActivity: {
            "success": "La actividad se editó con éxito.",
            "error": "Ocurrió un error al editar la actividad."
        },
        deleteDestination: {
            "success": "El destino de eliminó con éxito.",
            "error": "Ocurrió un error al eliminar el destino."
        },
        updateDestination: {
            "success": "El destino de editó con éxito.",
            "error": "Ocurrió un error al editar el destino."
        },
        convertInUnity: {
            "success": "El destino fue convertido en una unidad con éxito.",
            "error": "Ocurrió un error al convertir el destino en una unidad.",
            "errorId": "Ocurrió un error este identificador ya está asociado a otra unidad."
        },
        resendReport: {
            "success": "Los cortes diarios se reenviaron correctamente.",
            "error": "Ocurrió un error al reenviar los cortes diarios."
        },
        finishActivity: {
            "success": "La actividad se finalizó con éxito.",
            "error": "Ocurrió un error al finalizar la actividad."
        },
        cancelActivity: {
            "success": "La actividad se canceló con éxito.",
            "error": "Ocurrió un error al cancelar la actividad."
        },
        evidenceActivity: {
            "success": "Las evidencias se guardaron con éxito.",
            "error": "Ocurrió un error al guardar las evidencias."
        },
        forceActivity: {
            "success": "La actividad se cerró con éxito.",
            "error": "Ocurrió un error al cerrar la actividad."
        },
        reScheduleActivity: {
            "success": "La actividad se reagendó con éxito.",
            "error": "Ocurrió un error al reagendar la actividad."
        },
        resendActivity: {
            "success": "Se reenvió el informe con éxito.",
            "error": "Ocurrió un error al reenviar el informe."
        },
        deleteActivity: {
            "success": "La actividad se eliminó con éxito.",
            "error": "Ocurrió un error al eliminar la actividad."
        },
        seeInform: {
            "error": "Ocurrió un error al generar el informe la actividad."
        },
        range: {
            thereNoRange: 'No se encontró una configuración de localización para la tienda.',
            youAreOutside: 'Te encuentras fuera del rango de cobertura de la tienda.'
        },
        "catalog": {
            "create": {
                "success": "Se creó el tipo de actividad.",
                "error": "Ocurrió un error y el tipo de actividad no pudo ser creado."
            },
            "update": {
                "success": "Se actualizó el tipo de actividad.",
                "error": "Ocurrió un error y el tipo de actividad no pudo ser actualizado."
            },
            "delete": {
                "success": "Se eliminó el tipo de actividad.",
                "error": "Ocurrió un error y el tipo de actividad no pudo ser eliminado."
            }
        }
    },
    errors: {
        typeOfActivity: 'El campo tipo de actividad es requerido',
        nameDestination: 'El campo nombre del destino es requerido',
        activityTypeText: 'El campo texto libre es requerido'
    },
    errorsCode: {
        errorNotFoundUser: 'No se encontró el usuario',
        duplicatePplaces: 'El destino que intenta crear ya ha sido registrado, valida tus registros',
        errorNotFoundStore: 'No se encontró la unidad',
        errorNotFoundTypeActivity: 'No se encontró el tipo de actividad',
        errorOutDate: 'La fecha tiene un error',
        errorEmptyData: 'No hay datos para almacenar',
        errorFieldsAllow: 'La actividad tiene campos incompletos',
        validationError: 'El titulo de la actividad es obligatorio',
    }
}